import React, { useState, useEffect } from "react";

//MUI
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import Alert from "@mui/material/Alert";
import Grid from "@mui/material/Grid";

import { DataGrid } from "@mui/x-data-grid";

//Icons
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import MoreVertIcon from "@mui/icons-material/MoreVert";

import DeleteUserDialog from "../../components/dialogs/deleteGeneric";
import CreateUserDialog from "../../components/dialogs/createUser";
import UpdateUserDialog from "../../components/dialogs/updateUser";
import UserPopover from "../../components/popovers/generic";

import mainURL from "../../config/environment";
import $ from "jquery";
import { Box, useTheme } from "@mui/material";

const emptyData = {
  id: 0,
  fullName: "",
  email: "",
  phoneNumber: "",
  roleId: 0,
  mapURL: "",
  mapTitle: "",
};

const usePermissions = (refresh) => {
  const [permissions, setPermissions] = useState([]);
  useEffect(() => {
    const token = JSON.parse(localStorage.getItem("userInfo")).token;
    const roleId = JSON.parse(localStorage.getItem("userInfo")).roleId;
    $.ajax({
      method: "GET",
      url: mainURL + `permissions/${roleId}`,
      contentType: "application/json",
      headers: {
        Authorization: "Bearer " + token,
      },
    }).done((res) => {
      const aux = [];
      res.forEach((element) => {
        if (element.isAssigned) aux.push(element.permission);
      });
      setPermissions(aux);
    });
  }, []);
  return permissions;
};

const deleteMessage = "Something went wrong";


export default function Users(props) {
  const { isAmericas } = props;
  const theme = useTheme();
  //Permission management
  const permissions = usePermissions();
  const addPermission = permissions.find((x) => x === 2);
  const updatePermission = permissions.find((x) => x === 3);
  const impersonatePermission = permissions.find((x) => x === 15);

  const screenSize = window.innerWidth;

  //Data management
  const [selectedData, setSelectedData] = useState(emptyData);
  const [refresh, setRefresh] = useState(false);
  const [data, setData] = useState([]);

  let columns: GridColDef[] = [
    {
      headerName: "Fullname",
      field: "fullName",
      flex: 1,
    },
    {
      headerName: "Email",
      field: "email",
      flex: 1,
    },
    {
      headerName: "Phone number",
      field: "phoneNumber",
      flex: 1,
    },
    {
      headerName: "Role",
      field: "roleName",
      flex: 1,
    },
    {
      headerName: "Client",
      field: "clientName",
      flex: 1,
    },
    {
      headerName: "Last login",
      field: "lastLogin",
      flex: 1,
      renderCell: (params: GridRenderCellParams) => (
        <span>
          {params.row.lastLogin !== "0001-01-01T00:00:00"
            ? new Date(params.row.lastLogin).toLocaleString()
            : "Not logged in yet"}
        </span>
      ),
    },
    {
      headerName: "Options",
      field: "id",
      renderCell: (params: GridRenderCellParams) => (
        <IconButton onClick={handlePopoverOpen(params.row)}>
          <MoreVertIcon />
        </IconButton>
      ),
      //flex: 1,
      align: "center",
      headerAlign: "center",
      sortable: false,
      editable: false,
    },
  ];

  if (!updatePermission) {
    columns = columns.filter((x) => x.headerName !== "Options");
  }

  if (screenSize < 600) {
    columns = columns.filter(
      (x) => x.headerName === "Options" || x.headerName === "Fullname"
    );
  }

  //Dialog management
  const [createDialog, setCreateDialog] = useState(false);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [updateDialog, setUpdateDialog] = useState(false);
  const handleCloseDialogs = () => {
    setCreateDialog(false);
    setDeleteDialog(false);
    setUpdateDialog(false);
  };

  //Notification management
  const [showNotification, setShowNotification] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState({
    severity: "",
    message: "",
  });

  const handleShowNotification = (severity, message) => {
    setNotificationMessage({ severity: severity, message: message });
    setShowNotification(true);
    setTimeout(function () {
      setShowNotification(false);
    }, 5000);
  };

  //Popover management
  const [anchor, setAnchor] = useState(null);
  const handlePopoverOpen = (selected) => (event) => {
    event.stopPropagation();
    setAnchor(event.currentTarget);
    setSelectedData(selected);
  };

  const handlePopoverClose = () => {
    setAnchor(null);
  };

  const handleSelect = (data) => {
    if (data.row !== selectedData) setSelectedData(data.row);
    else setSelectedData(emptyData);
  };

  const handleSendInvite = () => {
    console.log("inviting");
    const token = JSON.parse(localStorage.getItem("userInfo")).token;

    $.ajax({
      method: "POST",
      url: mainURL + `user/${selectedData.id}/invite-user`,
      contentType: "application/json",
      headers: {
        Authorization: "Bearer " + token,
      },
    })
      .done((res) => {
        //setLoading(false);
        handleShowNotification("success", "Invitation sent");
      })
      .fail((res) => {
        handleShowNotification("error", res.responseText);
      });
  };

  useEffect(() => {
    const token = JSON.parse(localStorage.getItem("userInfo")).token;
    let isSubscribed = true;
    //handleShowNotification("info", "Loading users");
    $.ajax({
      method: "GET",
      url: mainURL + "user/get-all",
      contentType: "application/json",
      headers: {
        Authorization: "Bearer " + token,
      },
    })
      .done((res) => {
        //console.log(res);
        res = res.filter((x) => x.id > 0);
        const aux: GridRowsProp = res;
        if (isSubscribed) {
          setData(aux);
          setSelectedData(emptyData);
          //handleShowNotification("success", "Users loaded successfully");
        }
      })
      .fail((res) => {
        handleShowNotification("error", res.responseText);
      });
    return () => (isSubscribed = false);
  }, [refresh]);

  return (
    <Grid container direction="column" sx={{ p: 3, pt: 0 }}>
      <UserPopover
        open={anchor}
        showUpdateUser
        showInviteOption
        showImpersonateOption={impersonatePermission}
        userId={selectedData.id}
        handleClose={handlePopoverClose}
        setUpdateDialog={setUpdateDialog}
        setDeleteDialog={setDeleteDialog}
        handleSendInvite={handleSendInvite}
      />
      <DeleteUserDialog
        refresh={refresh}
        open={deleteDialog}
        setRefresh={setRefresh}
        title={"Delete user"}
        name={selectedData.fullName}
        errorMessage={deleteMessage}
        handleClose={handleCloseDialogs}
        deleteURL={`user/${selectedData.id}`}
        handleShowNotification={handleShowNotification}
      />
      <CreateUserDialog
        refresh={refresh}
        open={createDialog}
        setRefresh={setRefresh}
        isAmericas={isAmericas}
        handleClose={handleCloseDialogs}
        handleShowNotification={handleShowNotification}
      />
      <UpdateUserDialog
        refresh={refresh}
        open={updateDialog}
        setRefresh={setRefresh}
        userId={selectedData.id}
        handleClose={handleCloseDialogs}
        handleShowNotification={handleShowNotification}
      />



      <Grid
        justifyContent={"space-between"}
        alignItems={"center"}
        sx={{ p: "2rem 0" }}
        spacing={2}
        container
      >
        <Grid item xs={8} md={8}>
          <Box >  <Typography variant="h5" sx={{ color: theme.palette.gray.dark, fontWeight: '600' }}> Users</Typography>
            <Typography variant="body2" sx={{ color: theme.palette.gray.main }}> Manage the users here.</Typography></Box>
        </Grid>


        {showNotification ? (
          <Grid item xs={12} md={4}>
            <Alert variant="outlined" severity={notificationMessage.severity}>
              {notificationMessage.message}
            </Alert>
          </Grid>
        ) : addPermission ? (
          <Grid item xs={4} md={4} container justifyContent="flex-end">
            <Button variant="contained" sx={{
              textTransform: 'unset',
              backgroundColor: theme.palette.blues.main,
              fontWeight: '600',
              fontSize: '14px',
            }} onClick={() => setCreateDialog(true)}>
              <PlaylistAddIcon sx={{ mr: 1 }} />
              {"Add"}
            </Button>
          </Grid>
        ) : null}
      </Grid>

      <Grid container height={"60vh"}>
        <DataGrid
          selectionModel={selectedData.id === 0 ? [] : selectedData.id}
          onRowClick={handleSelect}
          columns={columns}
          disableColumnMenu
          autoPageSize
          rows={data}
        />
      </Grid>
    </Grid>
  );
}
